import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(housingAssociationHistoryIssueList);

    /** @ngInject */
    function housingAssociationHistoryIssueList($stateProvider) {
        $stateProvider.state('housing_association.history_issue_list', {
            url: '/historia',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/housing_association_issue_list/history/history.html'),
            controller: 'HousingAssociationHistoryIssueListController',
            controllerAs: 'HousingAssociationHistoryIssueListCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/housing_association_issue_list/history/history.route.ts